import { EMPTY_SYMBOL_24, ISDSIcon } from "@sznds/icons";
import { _ } from "~/i18n";
import { TActivityType } from "~/interfaces";
import { ACTIVITY_TYPE_TO_ICON } from "./constants";

export function backAction(_event, likeData) {
	if (likeData) {
		Mapy.getComponent("activities").state = {};
		Mapy.getComponent("places").state = { mid: likeData.parent_id };
		Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("places"));
		Mapy.getComponent("dimcurator").setState();
	} else {
		Mapy.getComponent("activities").state = {};
		Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("activities"));
	}
	Mapy.getComponent("history").save();
}

export function activityTypeToName(type: TActivityType): string {
	switch (type) {
		case "auto_moto":
			return _("activity.type.auto_moto");

		case "beh":
			return _("activity.type.beh");

		case "bezky":
			return _("activity.type.bezky");

		case "gravel":
			return _("activity.type.gravel");

		case "horolezectvi":
			return _("activity.type.horolezectvi");

		case "horske_kolo":
			return _("activity.type.horske_kolo");

		case "inline":
			return _("activity.type.inline");

		case "jezdectvi":
			return _("activity.type.jezdectvi");

		case "karavan":
			return _("activity.type.karavan");

		case "kocarek":
			return _("activity.type.kocarek");

		case "kolobezka":
			return _("activity.type.kolobezka");

		case "letadlo":
			return _("activity.type.letadlo");

		case "motorka":
			return _("activity.type.motorka");

		case "nakole":
			return _("activity.type.nakole");

		case "paddleboard":
			return _("activity.type.paddleboard");

		case "paraglide":
			return _("activity.type.paraglide");

		case "pesky":
			return _("activity.type.pesky");

		case "silnicni_kolo":
			return _("activity.type.silnicni_kolo");

		case "sjezd":
			return _("activity.type.sjezd");

		case "skialpy":
			return _("activity.type.skialpy");

		case "sneznice":
			return _("activity.type.sneznice");

		case "vodactvi":
			return _("activity.type.vodactvi");

		default:
			return "";
	}
}

export function activityTypeToIcon(type: TActivityType): ISDSIcon {
	if (type in ACTIVITY_TYPE_TO_ICON) {
		return ACTIVITY_TYPE_TO_ICON[type];
	}

	return EMPTY_SYMBOL_24;
}
